module.exports = __webpack_public_path__ + "static/media/Shop_VIP_Divider_Glows.7acc8553.png";